/**
 * 注册相关函数
 */
import dayjs from 'dayjs'
import {
  platformCenterReloadAuthenticate,
  userAuditCreateOrUpdateA,
  userAuditGetPaged
} from '@/api/platformCenter'
import {
  SqlitePageConfigurationGetPaged,
  dynamicTemplateGetPaged
} from '@/api/Sqlite'
import { userCenterALogin } from '@/api/user'

/**
 * 获取aToken（模拟登陆）
 * @param {*} userName 用户名
 * @param {*} password 密码
 * @param {*} aTenantId
 */
export async function getAUserToken(userName, password, aTenantId) {
  const headers = {
    'Abp.TenantId': aTenantId
  }
  const { result } = await userCenterALogin(
    {
      userNameOrEmailAddress: userName,
      password
    },
    headers
  )
  return {
    A_ACCESS_TOKEN: result?.accessToken // atoken
  }
}
/**
 * 获取bToken
 * @param {*} authProvider aTenantID
 * @param {*} platformId bTenantID
 * @param {*} providerKey aUserID
 * @param {*} Authorization aToken
 * @returns
 */
export async function getbUserToken(
  authProvider = '',
  platformId = '',
  providerKey = '',
  Authorization = ''
) {
  const headers = {
    'Abp.TenantId': authProvider,
    Authorization: `Bearer ${Authorization}`
  }
  const { result } = await platformCenterReloadAuthenticate(
    {
      authProvider,
      platformId,
      providerKey
    },
    headers
  )
  return {
    ACCESS_TOKEN: result?.accessToken // btoken
  }
}

// 获取平台设置数据
export async function getPlatformConfiguration(tenantId, reqHeaders) {
  try {
    const { result, success } = await dynamicTemplateGetPaged(
      {
        filter: 'customTag like "platformSettingForm"'
      },
      reqHeaders
    )
    if (success) {
      // 获取模板id
      const platformSettingForm = result?.items?.[0] || {}
      // 读取配置信息
      const templateId = platformSettingForm?.id || ''
      if (
        Object.keys(platformSettingForm).length === 0 ||
        templateId === ''
      ) {
        throw new Error('找不到配置信息')
      }
      const params = {
        filter: `tenantId == "${tenantId}" && templateId == "${templateId}"`
      }
      const { result: configRes } = await SqlitePageConfigurationGetPaged(params, reqHeaders)
      const item = configRes.items.filter((v) => v.id === '')?.[0]
      return JSON.parse(item?.content || '{}')
    } else {
      throw new Error('获取配置信息失败')
    }
  } catch (e) {
    console.log(e.message)
    return false
  }
}

/**
 * 判断是否免审入库
 * @param {*} platformConfiguration
 */
export function checkIsNonUserAudit(platformConfiguration) {
  return platformConfiguration.isNonUserAudit === '1' // '1' - 免审入库；'2' - 需要审核
}

/**
 * 创建userAudit数据（默认通过status = '2'）
 * @param {object} registerInfo
 * @param {string} status
 * @returns
 */
export async function creataUserAuditData(
  registerInfo = {
    companyId: '',
    companyName: '',
    name: '',
    provider: '',
    providerKey: '',
    tenantId: 0,
    userId: 0,
    userName: ''
  },
  status = '2',
  headers
) {
  // 检查是否有历史数据
  const { result: userAuditRes } = await userAuditGetPaged({
    filter: `tenantId == "${registerInfo.tenantId}" && companyId == "${registerInfo.companyId}" && provider == "${registerInfo.provider}" && providerKey == "${registerInfo.providerKey}"`
  }, headers)
  if (userAuditRes.totalCount > 0) {
    return userAuditRes.items[0]
  } else {
    const params = {
      applicationTime: dayjs().format('YYYY-MM-DD HH:mm:ss'),
      auditDate: '',
      auditName: '',
      auditType: '',
      comment: 'ocr认证通过',
      companyId: registerInfo.companyId,
      companyName: registerInfo.companyName,
      name: registerInfo.name,
      provider: registerInfo.provider,
      providerKey: registerInfo.providerKey,
      status,
      tenantId: registerInfo.tenantId,
      userId: registerInfo.userId,
      userName: registerInfo.userName
    }
    const { result } = await userAuditCreateOrUpdateA(params, headers)
    console.log(result)
    return result
  }
}
